export interface Ts1V3SignOffRow {
	candidateId?: string;
	trainerSignature?: unknown;
	trainerName?: string;
	instructorLicenseNumber?: string;
}

export function canSendTs1V3ToCandidate(rows: Ts1V3SignOffRow[]): boolean {
	if (!rows.length) return false;

	const instructor = rows[0];
	if (!instructor?.trainerSignature || !String(instructor.trainerName ?? "").trim()) {
		return false;
	}
	if (!String(instructor.instructorLicenseNumber ?? "").trim()) {
		return false;
	}

	return true;
}
